function createErrorHandler(fieldError, fieldName, setFieldError) {
  return (error) => {
    if (error !== fieldError && error !== "") {
      setFieldError(fieldName, error ? String(error) : void 0);
    }
  };
}
export {
  createErrorHandler
};
//# sourceMappingURL=errorHandler.js.map
